/* eslint-disable no-case-declarations */

import moment from 'moment';
import { FETCH_REQUESTS_INCOMING } from '../../actions/requests';
import { RESET_COMPANY_CONTEXT } from '../../actions';

const requestsIncomingInitState = {
  loading: false,
  majorReload: false,
  error: null,
  lastUpdated: moment(),
  data: {
    page: 0,
    size: 0,
    total: 0,
    requestsIncoming: [],
  },
};

export default function requestsIncomingReducer(state = null, { type, payload, meta }) {
  switch (type) {
    case FETCH_REQUESTS_INCOMING.START:
      return {
        ...state, loading: true, majorReload: !payload.silentRefresh, actionId: payload.actionId, data: {},
      };
    case FETCH_REQUESTS_INCOMING.SUCCESS: {
      if (state.actionId !== meta.previousAction.payload.actionId) {
        return state;
      }

      return {
        ...state,
        data: {
          page: payload.data.number,
          size: payload.data.size,
          total: payload.data.totalElements,
          requestsIncoming: payload.data.content,
        },
        loading: false,
        majorReload: false,
        error: undefined,
        lastUpdated: moment(),
      };
    }
    case FETCH_REQUESTS_INCOMING.FAIL:
      if (state.actionId !== meta.previousAction.payload.actionId) {
        return state;
      }
      return {
        ...state,
        loading: false,
        majorReload: false,
        error: payload,
        data: requestsIncomingInitState.data,
        lastUpdated: moment(),
      };
    case RESET_COMPANY_CONTEXT:
      return { ...requestsIncomingInitState };
    default:
      return state;
  }
}
